export enum FrequencyTypeEnum {
  AllData = 'all',
  EveryMinute = '1m',
  EveryHour = '1h',
  EveryDay = '1d'
}
